import { apiClient } from './apiClient';
import type {
  BusinessParentChildAssociation,
  ConfirmBusinessParentChildRequest,
  ConfirmBusinessParentChildResponse,
} from '../types/businessParentChild';

export const businessParentChildService = {
  /**
   * Get association details by token
   * Used on the confirmation page to show association info
   */
  async getAssociationByToken(token: string): Promise<BusinessParentChildAssociation> {
    return apiClient.get<BusinessParentChildAssociation>(
      `/business-parent-child/confirm/${encodeURIComponent(token)}`
    );
  },

  /**
   * Confirm or reject an association
   */
  async confirmAssociation(
    data: ConfirmBusinessParentChildRequest
  ): Promise<ConfirmBusinessParentChildResponse> {
    return apiClient.post<ConfirmBusinessParentChildResponse>(
      '/business-parent-child/confirm',
      data
    );
  },
};
